import { z } from "zod";

//ObraAlvenariaEstruturalSchema


export const ObraAlvenariaEstruturalSchema = z.object({
  DataRecebimento: z.coerce.date({ invalid_type_error: "Data de recebimento inválida.", required_error: 'Este campo deve ser preenchido!' }),
  Dimensao: z.string().nullable().optional(),
  TipoBloco: z.string().nullable().optional(),
  NroNotaFiscal: z.string().nullable().optional(),
  ResistenciaSolicitada: z.string().nullable().optional(),
  QtdeRecibida: z.coerce.number().nullable().optional(),
  Fornecedor: z.string().nullable().optional(),
  NomeLaboratorio: z.string().nullable().optional(),
  LocalAplicacao: z.string().nullable().optional(),
  EnsaiosSolicitados: z.string().nullable().optional(),
  DataEnvio: z.coerce.date({ invalid_type_error: "Data de ensaios inválida." }).nullable().optional(),
  NrCorpoProva: z.string().nullable().optional(),
  NrAmostras: z.string().nullable().optional(),
  Ensaio1: z.string().nullable().optional(),
  Ensaio2: z.string().nullable().optional(),
  NroAmostras1: z.string().nullable().optional(),
  NroAmostras2: z.string().nullable().optional(),
  EspecificacaoArgamassa: z.string().nullable().optional(),
  RbIdade1: z.string().nullable().optional(),
  RbIdade2: z.string().nullable().optional(),
  RbIdade3: z.string().nullable().optional(),
  RbResultado1: z.string().nullable().optional(),
  RbResultado2: z.string().nullable().optional(),
  RbResultado3: z.string().nullable().optional(),
  RaIdade1: z.string().nullable().optional(),
  RaIdade2: z.string().nullable().optional(),
  RaIdade3: z.string().nullable().optional(),
  RaResultado1: z.string().nullable().optional(),
  RaResultado2: z.string().nullable().optional(),
  RaResultado3: z.string().nullable().optional(),
  Aprovado: z.coerce.number().nullable().optional(),
  IdFuncionario: z.number().nullable().optional(),
  Observacao: z.string().nullable().optional(),
  Arquivo1: z.instanceof(File).nullable().optional(),
  Arquivo2: z.instanceof(File).nullable().optional(),
  DescResponsavel: z.string().nullable().optional(),
  ResponsavelCadastrado: z.boolean().nullable().optional(),
  funcionarioNome: z.string().nullable().optional(),
  limparArquivo1: z.boolean().default(false),
  limparArquivo2: z.boolean().default(false),
});

//ObraAlvenariaEstruturalForm

export type ObraAlvenariaEstruturalForm = z.infer<typeof ObraAlvenariaEstruturalSchema>;